import React from 'react';

const SaveIcon = () => <i className="material-icons align-bottom">save</i>;
const SaveOutline = () => <i className="material-icons-outlined align-bottom">save</i>;

export { SaveIcon as default, SaveOutline };
